export const SUPPORT_URLS = {
    getSupport: "https://www.zucchetti.it/cas/login",
    manuals: "https://help.zucchetti.it/cms/kb/soluzioni/hospitality/ristorazione/tilby",
    shareScreen: "https://help.zucchetti.it/cms/kb/soluzioni/hospitality/ristorazione/tilby/consigli-operativi/operazioni-comuni/scarica-il-componente-di-controllo-remoto.html?pCurrentCategory=900&pKBCODICE=zhelpkb"
};
